import { useForm } from 'react-hook-form';
import {
  Input,
  Button,
  FormControl,
  Modalv2,
  ModalHeader,
  ModalBody,
  ModalFooter
} from '@itandi/itandi-bb-ui';
import { toast } from 'react-toastify';
import { useCallback, useState } from 'react';
import type { AdminCompanyStoreSettingEdit } from '~/models/CompanyStoreSetting';
import Styles from './CompanyStoreSettingForm.module.scss';
import { update } from '~/utils/api/admin/CompanyStoreSetting';
import { isSuccess } from '~/utils/api/api_handler';

type Props = {
  companyStoreSetting: AdminCompanyStoreSettingEdit;
};

export const CompanyStoreSettingForm: React.FC<Props> = ({
  companyStoreSetting
}) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const { register, getValues, handleSubmit } =
    useForm<AdminCompanyStoreSettingEdit>({
      defaultValues: {
        robotPaymentStoreCode: companyStoreSetting.robotPaymentStoreCode
      },
      mode: 'onBlur'
    });
  const onClickSubmit = useCallback(() => {
    handleSubmit(() => {
      setIsConfirmModalOpen(true);
    })();
  }, [handleSubmit]);
  const handleAccept = useCallback(async () => {
    const values = getValues();
    const response = await update(values);
    if (isSuccess(response)) {
      toast.success('保存しました');
      setIsConfirmModalOpen(false);
      return;
    }
    toast.error('保存に失敗しました');
  }, [getValues]);
  return (
    <div className={Styles.FormContainer}>
      <FormControl label="請求管理ロボ用店舗コード" variant="Vertical">
        <Input {...register('robotPaymentStoreCode')} />
      </FormControl>
      <div>
        <Button onClick={onClickSubmit} variant="primary">
          保存
        </Button>
      </div>
      <Modalv2
        isOpen={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        size="s"
      >
        <ModalHeader title="設定の保存" />
        <ModalBody>設定を保存します。</ModalBody>
        <ModalFooter
          leftArea={
            <Button
              onClick={() => {
                setIsConfirmModalOpen(false);
              }}
              variant="secondary"
            >
              キャンセル
            </Button>
          }
          rightArea={
            <Button onClick={handleAccept} variant="primary">
              保存
            </Button>
          }
        />
      </Modalv2>
    </div>
  );
};
